import { LocationType } from "./Enums";

export class AlertParameters {
	scheduleId: number = 0;
	dispatchId: number = 0;
	locationType: LocationType = LocationType.Origin;
	locCode: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	//customerId: number = 0;
	truckerId: number = 0;
	//truckerName: string = '';
	selectedLocCodeInFilter?: string = '';
	isRequestFromSendTextAlertForm: boolean = false;
}